import useDateTimeDisplay from './useDateTimeDisplay';
import useDateTimeNow from './useDateTimeNow';
import {occurrenceCalendarRequestScope} from '@liquid-spirit/api/domains/events';
import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { discoverActivitiesQuery, discoverEventsQuery } from '../queries/discoverQueries';
import useQueryScope from '../queries/useQueryScope';

export const usePrefetch = ({ user, token }) => {
  const queryClient = useQueryClient();
  const { scope, isCurrent, enabled } = useQueryScope({ user, token });
  const {display} = useDateTimeDisplay();
  const now = useDateTimeNow();
  const calendar = occurrenceCalendarRequestScope({displayTimeZone: display.timeZone, now});
  const calendarRef = useRef(calendar); calendarRef.current = calendar;
  const userId = user?._id || user?.id || user?.userId || null;
  useEffect(() => {
    if (!userId || !token || !enabled || typeof window === 'undefined') return undefined;
    const prefetchDiscover = () => {
      if (!isCurrent()) return Promise.resolve();
      const options = { token, queryClient, isCurrent };
      return Promise.all([
        queryClient.prefetchQuery(discoverActivitiesQuery(scope, options)),
        queryClient.prefetchQuery(discoverEventsQuery(scope, {...options, calendarScope: calendarRef.current})),
      ]);
    };
    window.__ls_prefetch = window.__ls_prefetch || {};
    window.__ls_prefetch.discover = prefetchDiscover;
    return () => {
      if (window.__ls_prefetch?.discover === prefetchDiscover) delete window.__ls_prefetch.discover;
    };
  }, [enabled, isCurrent, queryClient, scope, token, userId, calendar.key]);
};
